"use strict";
import "lodash";
import { svc_fetchAll, svc_addOne, svc_editOne, svc_deleteOne } from "@/services";
import { showServerResponse } from "@/utils/message";
import logger from "@/utils/logger";

const endpointBasePrefix = "malls";

const Model = {
	namespace: "m_Malls",
	state: {
		malls: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { malls } }) {
			return { ...state, malls };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let malls = yield call(svc_fetchAll, endpointBasePrefix);
			_.forEach(malls, function (row) {
				row.key = row.id;
				row.sector_id = row.sector_info.id;
				row.sector_name = row.sector_info.name;
				row.sector_desc = row.sector_info.description;
				delete row.sector_info;
			});

			yield put({
				type: "handleFetchAll",
				payload: { malls },
			});

			return malls;
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key", "sector_name", "sector_desc","id","ct_isChanged"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			return showServerResponse(response);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key", "sector_name", "sector_desc","ct_isChanged"]);
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key", "sector_name", "sector_desc"]);
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
